





import { Component, Prop, Vue, Emit } from 'vue-property-decorator'
import {MDCRipple} from '@material/ripple'
@Component({})
export default class MdcRipple extends Vue{
  @Prop({default:'div'}) tag!:string
  @Prop({default:undefined}) to?:string

  @Prop({default:true}) js!:boolean

  get _tag():string{
    if(this.to !== undefined){
      return 'router-link'
    }
    return this.tag
  }
  ripple?:MDCRipple
  mounted(){
    if(this.js){
      this.ripple= new MDCRipple(this.$el as Element)
    }
  }
  beforeDestory(){
    if(this.ripple !== undefined){
      this.ripple.destroy()
    }
  }
  @Emit()
  click(){

  }
}
